module.exports = __webpack_public_path__ + "assets/captain-marker.803b54419ccb273a94fec78cf671799e.png";